import React, { useEffect, useState, useMemo } from "react";
import { NavLink, Link } from "react-router-dom";
import axios from "axios";
import logo from "../../assets/images/horizontal/variacao_chapado.png";
import congolinaria from "../../assets/images/horizontal/negativo.png";
import pagamento from "../../assets/images/forma_pagamento.png";
import selo from "../../assets/images/selossl.png";

export default function FooterHortifruti() {
  const [categorias, setCategorias] = useState([]);

  useEffect(() => {
    const url = "https://congolinaria.com.br/api/categorias_hortifruti.php";

    axios
      .get(url, { timeout: 15000 })
      .then((res) => {
        const arr = Array.isArray(res.data) ? res.data : [];

        const norm = arr
          .map((c) => ({
            id: Number(c.id ?? c.categoria_id ?? 0),

            // ✅ PRODUÇÃO: tabela tem nome_pt / nome_en / nome_es / nome_fr
            nome: String(
              c.nome_pt ??
                c.nome ??
                c.titulo ??
                c.categoria ??
                c.nome_categoria ??
                ""
            ).trim(),

            ordem: Number(c.ordem ?? 0),
          }))
          .filter((c) => c.id > 0 && c.nome);

        norm.sort((a, b) => {
          if (a.ordem && b.ordem) return a.ordem - b.ordem;
          return a.nome.localeCompare(b.nome, "pt-BR");
        });

        setCategorias(norm);
      })
      .catch(() => {
        setCategorias([
          { id: 1, nome: "Legumes" },
          { id: 2, nome: "Verduras" },
          { id: 6, nome: "Frutas" },
          { id: 3, nome: "Temperos" },
          { id: 4, nome: "Cogumelos" },
          { id: 5, nome: "Castanhas e Grãos" },
        ]);
      });
  }, []);

  const navLinks = useMemo(() => {
    const links = [{ to: "/hortifruti", label: "Início", id: "inicio" }];

    categorias.forEach((c) => {
      links.push({
        to: `/hortifruti?cat=${c.id}`,
        label: c.nome,
        id: c.id,
      });
    });

    return links;
  }, [categorias]);

  return (
    <footer className="bg-[#144D3A] text-white pt-10 pb-4 px-6 md:px-16">
     



      {/* Seções principais */}
            <div className="grid grid-cols-1 md:grid-cols-3 gap-10 mb-10">
              
              {/* Navegação */}
              {/* COLUNA 2 – NAV DINÂMICO */}
        <div>
          <h3 className="text-xl font-semibold mb-4 text-yellow-400">
            Navegar
          </h3>

          <ul className="space-y-2 text-sm">
            {navLinks.map((item) => (
              <li key={item.id}>
                <NavLink
                  to={item.to}
                  end={item.to === "/hortifruti"}
                  className={({ isActive }) =>
                    `transition font-medium ${
                      isActive ? "text-white" : "text-white"
                    } hover:text-yellow-300 transition`
                  }
                >
                  {item.label}
                </NavLink>
              </li>
            ))}
          </ul>
        </div>
      
              {/* Contato */}
              <div>
                <h3 className="text-xl font-semibold mb-4 text-yellow-400">Central de Atendimento</h3>
                <ul className="space-y-2 text-sm">
                  <li><a href="tel:+5511980451471" className="hover:text-yellow-300 transition">+55 (11) 94548-1925</a></li>
                   <li><a href="mailto:congolinaria.sp@gmail.com" className="hover:text-yellow-300 transition">congolinaria.sp@gmail.com</a></li>
                   <li>Rua Caquito, 251 — Próx. Mercado Municipal Penha - SP</li>
                </ul>
              </div>
      
              {/* Redes Sociais */}
              <div>
                <h3 className="text-xl font-semibold mb-4 text-yellow-400">Redes Sociais</h3>
                <ul className="space-y-2 text-sm">
                  <li><a href="https://www.facebook.com/congolinaria" className="hover:text-yellow-300 transition"><i className="fa-brands fa-facebook mr-2"></i>Facebook</a></li>
                  <li><a href="https://www.instagram.com/congolinaria" className="hover:text-yellow-300 transition"><i className="fa-brands fa-instagram mr-2"></i>Instagram</a></li>
                  <li><a href="https://www.youtube.com/pitchoubresil" className="hover:text-yellow-300 transition"><i className="fa-brands fa-youtube mr-2"></i>YouTube</a></li>
                  <li><a href="#" className="hover:text-yellow-300 transition"><i className="fa-brands fa-twitter mr-2"></i>Twitter</a></li>
                  <li><a href="#" className="hover:text-yellow-300 transition"><i className="fa-brands fa-linkedin mr-2"></i>LinkedIn</a></li>
                </ul>
              </div>
            </div>
      
            {/* Segunda linha */}
            <div className="grid grid-cols-1 md:grid-cols-3 gap-10 border-t border-neutral-700 pt-10">
              {/* Logo + Descrição */}
              <div>
                <img src={logo} alt="Logo Congolinaria" className="w-56 mb-4" />
                  <p className="text-sm text-[#E5E7EB]">
            Alimentar o corpo, celebrar a cultura, fortalecer o povo.
          </p>

          <p className="text-xs mt-4 text-[#C9A23F]">
            CNPJ do Congolinaria Empório: 45.033.649/0001-47
          </p>
              </div>
      
              {/* Forma de pagamento */}
              <div>
                <h3 className="text-xl font-semibold mb-4 text-yellow-400">Formas de Pagamento</h3>
                <img src={pagamento} alt="Formas de pagamento" className="w-64 rounded-md" />
              </div>
      
              {/* Selo de segurança */}
              <div>
                <h3 className="text-xl font-semibold mb-4 text-yellow-400">Selo de Segurança</h3>
                <img src={selo} alt="Selo de segurança" className="w-56" />
              </div>
            </div>
      
            {/* Rodapé final */}
            <div className="text-center mt-10 text-xs text-gray-400 border-t border-neutral-800 pt-4">
              © {new Date().getFullYear()} Hortifruti Congolinaria — Todos os direitos
        reservados.
            </div>
    </footer>
  );
}
